import { Instagram } from "lucide-react";
import { LegalDocuments } from "@/components/LegalDocuments";

const TIKTOK_URL = "https://www.tiktok.com/@contadora.online.arg?_r=1&_t=ZS-94fKEsQQX8C";
const INSTA_URL = "https://www.instagram.com/contadora.online.arg";

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.7a8.18 8.18 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.13z" />
  </svg>
);

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-navy-900 py-12 text-cream-300 md:py-16"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
          <div className="text-center md:text-left">
            <p className="font-poppins text-lg font-semibold text-white">
              Bárbara <span className="text-gold">Cargnello</span>
            </p>
            <p className="mt-1 font-inter text-sm text-cream-400">
              Contadora Pública
            </p>
            <address className="not-italic mt-3">
              <p className="font-inter text-sm text-cream-500">
                T 368 F 185 - CPCECABA
              </p>
              <p className="mt-1 font-inter text-sm text-cream-500">
                T 169 F 81 Legajo N 43900/2 - CPCEPBA
              </p>
            </address>
          </div>

          <nav aria-label="Redes sociales de Bárbara Cargnello">
            <div className="flex items-center gap-4">
              <a
                href={INSTA_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram de Bárbara Cargnello"
                data-testid="footer-instagram-link"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition-colors duration-200 hover:bg-gold/20"
              >
                <Instagram className="h-4 w-4 text-cream-200" strokeWidth={1.5} />
              </a>
              <a
                href={TIKTOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok de Bárbara Cargnello"
                data-testid="footer-tiktok-link"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 transition-colors duration-200 hover:bg-gold/20"
              >
                <TikTokIcon className="h-4 w-4 text-cream-200" />
              </a>
            </div>
          </nav>
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 border-t border-white/10 pt-8">
          <LegalDocuments />
          <p className="text-center font-inter text-sm text-cream-500">
            &copy; {year} Bárbara Cargnello - Contadora pública. Todos los derechos reservados.
          </p>
          <p className="text-center font-inter text-sm text-cream-600">
            Desarrollado por{" "}
            <a
              href="https://www.zenithcoreweb.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-cream-400 underline underline-offset-4 transition-colors duration-200 hover:text-gold"
            >
              Zenith Core
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

